module.exports = __webpack_public_path__ + "static/media/sao-luis-ma.645854b3.jpg";